
import { Skill } from '../types/game';

export const skills: Skill[] = [
  // Technical Skills
  {
    id: 'cooling-optimization',
    name: 'Cooling Optimization',
    category: 'Technical',
    description: 'Optimize cooling systems for mining operations, reducing energy costs and improving hardware longevity.',
    requiredExperience: 100
  },
  {
    id: 'hardware-maintenance',
    name: 'Hardware Maintenance',
    category: 'Technical',
    description: 'Efficiently maintain and repair mining equipment to minimize downtime and extend hardware lifespan.',
    requiredExperience: 50
  },
  {
    id: 'firmware-tuning',
    name: 'Firmware Tuning',
    category: 'Technical',
    description: 'Optimize miner firmware for maximum hashrate efficiency and stability.',
    requiredExperience: 75
  },
  {
    id: 'network-optimization',
    name: 'Network Optimization',
    category: 'Technical',
    description: 'Minimize latency and optimize network configuration for mining pools and security.',
    requiredExperience: 120,
    prerequisites: ['firmware-tuning']
  },
  {
    id: 'advanced-diagnostics',
    name: 'Advanced Diagnostics',
    category: 'Technical',
    description: 'Quickly identify and resolve complex hardware issues through sophisticated troubleshooting methods.',
    requiredExperience: 200,
    prerequisites: ['hardware-maintenance', 'firmware-tuning']
  },
  {
    id: 'custom-firmware-development',
    name: 'Custom Firmware Development',
    category: 'Technical',
    description: 'Design and implement proprietary firmware optimizations for maximum performance gains.',
    requiredExperience: 300,
    prerequisites: ['firmware-tuning', 'advanced-diagnostics']
  },
  
  // Business Skills
  {
    id: 'financial-planning',
    name: 'Financial Planning',
    category: 'Business',
    description: 'Create and manage comprehensive financial plans for mining operations with projected ROI analysis.',
    requiredExperience: 80
  },
  {
    id: 'hedging-strategies',
    name: 'Hedging Strategies',
    category: 'Business',
    description: 'Implement sophisticated risk management strategies to protect against market volatility and secure predictable returns.',
    requiredExperience: 200,
    prerequisites: ['financial-planning']
  },
  {
    id: 'investor-relations',
    name: 'Investor Relations',
    category: 'Business',
    description: 'Effectively communicate with and manage relationships with investors, securing funding and building trust.',
    requiredExperience: 150,
    prerequisites: ['financial-planning']
  },
  {
    id: 'market-analysis',
    name: 'Market Analysis',
    category: 'Business',
    description: 'Analyze Bitcoin market trends and macro factors to optimize mining profitability and timing of operations.',
    requiredExperience: 100
  },
  {
    id: 'venture-capital-funding',
    name: 'Venture Capital Funding',
    category: 'Business',
    description: 'Secure major capital investments through strategic pitching and business development.',
    requiredExperience: 350,
    prerequisites: ['investor-relations', 'financial-planning']
  },
  
  // Operations Skills
  {
    id: 'facility-management',
    name: 'Facility Management',
    category: 'Operations',
    description: 'Efficiently manage mining facility operations, infrastructure, and logistics for optimal performance.',
    requiredExperience: 90
  },
  {
    id: 'renewable-energy',
    name: 'Renewable Energy Integration',
    category: 'Operations',
    description: 'Integrate and optimize renewable energy sources into mining operations, reducing costs and environmental impact.',
    requiredExperience: 150
  },
  {
    id: 'regulatory-compliance',
    name: 'Regulatory Compliance',
    category: 'Operations',
    description: 'Navigate and ensure compliance with complex local and international regulations affecting mining operations.',
    requiredExperience: 130
  },
  {
    id: 'supply-chain',
    name: 'Supply Chain Management',
    category: 'Operations',
    description: 'Optimize the procurement and logistics of mining equipment across global supply networks.',
    requiredExperience: 120
  },
  {
    id: 'disaster-recovery',
    name: 'Disaster Recovery Planning',
    category: 'Operations',
    description: 'Develop and implement robust systems to quickly recover from catastrophic operational failures.',
    requiredExperience: 250,
    prerequisites: ['facility-management', 'regulatory-compliance']
  },
  
  // Leadership Skills
  {
    id: 'team-management',
    name: 'Team Management',
    category: 'Leadership',
    description: 'Lead and develop high-performing mining operation teams across technical and business domains.',
    requiredExperience: 100
  },
  {
    id: 'strategic-planning',
    name: 'Strategic Planning',
    category: 'Leadership',
    description: 'Develop long-term strategies for mining operations with clear execution roadmaps.',
    requiredExperience: 200,
    prerequisites: ['team-management']
  },
  {
    id: 'crisis-management',
    name: 'Crisis Management',
    category: 'Leadership',
    description: 'Effectively respond to and manage operational crises while minimizing negative impacts.',
    requiredExperience: 180,
    prerequisites: ['team-management']
  },
  {
    id: 'negotiation',
    name: 'Advanced Negotiation',
    category: 'Leadership',
    description: 'Secure exceptionally favorable terms for energy contracts, equipment purchases, and strategic partnerships.',
    requiredExperience: 150
  },
  {
    id: 'industry-influence',
    name: 'Industry Influence',
    category: 'Leadership',
    description: 'Shape industry standards and gain recognition as a thought leader in the mining community.',
    requiredExperience: 400,
    prerequisites: ['strategic-planning', 'negotiation']
  }
];
